import axios from 'axios'
import { getToken } from './auth-token'

// ENV.APP_URL is baked in at build time by the `define` block in vite.config.ts,
// so when it is set it is always the correct API origin — prefer it unconditionally.
//
// This replaced a `window.location.hostname === 'localhost' ? '/' : ENV.APP_URL`
// check, which could never work under Capacitor: the webview origin is
// capacitor://localhost on iOS and https://localhost on Android, so the check
// matched on every native build and pinned baseURL to the bundle's own origin,
// which serves static files and no API. It also caught the documented local
// mobile setup (client on :3001, API on :3000) — see docs/local-stack.html.
//
// Falling back to '/' preserves same-origin behaviour for the SSR web app, where
// APP_URL is empty in local dev and the API is served by the same process.
const baseURL = ENV.APP_URL || '/'

const axiosClient = axios.create({
	baseURL,
	timeout: 10000,
})

// Request interceptor to add authorization header and platform detection
axiosClient.interceptors.request.use(
	(config) => {
		const token = getToken()
		if (token) {
			config.headers.Authorization = `Bearer ${token}`
		}
		
		// Add Capacitor header for mobile platform detection
		// This allows the server to differentiate mobile from web requests
		config.headers['X-Capacitor'] = 'true'
		
		return config
	},
	(error) => {
		return Promise.reject(error)
	}
)

// Response interceptor for error handling
axiosClient.interceptors.response.use(
	(response) => response,
	(error) => {
		return Promise.reject(error)
	}
)

export default axiosClient
